import {Button, Grid, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useCallback, useEffect, useRef} from 'react'

import {DestinationPointDeliveryMethod} from '../types'
import {DropOffPointDetails} from './DropOffPointDetails/DropOffPointDetails'
import {PickupPointDetails} from './PickupPointDetails/PickupPointDetails'
import type {Props} from './types'

export function PointDetails(props: Props) {
  const {point, onChoose, pointType} = props
  const ref = useRef<HTMLDivElement>(null)
  const i18n = useI18n()

  const selectPointHandler = useCallback(() => {
    onChoose(point)
  }, [onChoose, point])

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({block: 'center'})
    }
  }, [ref])

  return (
    <Grid ref={ref} direction="column" container>
      {pointType === DestinationPointDeliveryMethod.PickUpPoint ? (
        <PickupPointDetails point={point} />
      ) : (
        <DropOffPointDetails point={point} />
      )}

      <Grid container item>
        <Grid item xs>
          <Button onPress={selectPointHandler} size="m" variant="action" fullWidth>
            <Typography Component={Grid} justify={'center'} thickness="medium" variant="body2" container>
              {i18n('ndd.pickup_points.select_point', 'Выбрать')}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
